export const SERVER_URL =
  process.env.NODE_ENV === "development" ? "http://localhost:8000" : "https://api.rousen.com";

export default {};
